<template>
	<div class="tijiaoZl">
		<header>
			<img src="../../assets/imgs/qiyeziliao/ziliao7.png" alt="">
			<h1>企业认证资料提交成功!</h1>
		</header>
		<section class="line"></section>
		<section class="neirong">
			<h3>请您于5个工作日内携带以下相关资料及物品，前往所属市县交易中心现场办理:</h3>
			<p>1:企业营业执照、法人身份证、经办人身份证、经办人委托书、销售合同、企业>公章、乡镇政府证明原件及复印件(复 印件需加盖公章) ;</p>
			<p>2:企业公章;</p>
			<p>3;支撑版本4.0以上安卓系统手机-部。</p>
		</section>
	</div>
</template>

<script>
export default {
	name:"qiyetijiaoZL",
	data(){
		return{

		}
	}
}
</script>
<style lang="less" scoped>
	.tijiaoZl{
		width: 980px;
		margin-left: 20px;
		background: #FFFFFF;
		box-shadow: 0 0 4px 0 rgba(0,0,0,0.10);
		border-radius: 10px;
		border-radius: 10px;
		min-height: 700px;
		header{
			background: #FFFFFF;
			height: 120px;
			display: flex;
			justify-content: center;
			align-items: center;
			img{
				width: 70px;
				height: 70px;
			}
			h1{
				margin-left: 20px;
				font-family: PingFangSC-Medium;
				font-size: 24px;
				color: #4A4A4A;
				letter-spacing: 0.45px;
			}
		}
		.line{
			width: 860px;
			border: 1px solid #EBEDF3;
			margin: 0 auto;
		}
		.neirong{
			width: 650px;
			margin-left: 200px;
			margin-top: 50px;
			h3{
				font-family: PingFangSC-Medium;
				font-size: 16px;
				color: #4A4A4A;
				letter-spacing: 0.3px;
				margin-bottom: 10px;
			}
			p{
				font-family: PingFangSC-Regular;
				font-size: 16px;
				color: #4A4A4A;
				letter-spacing: 0.3px;
			}
		}
	}
</style>
